import { SectionType } from '../../types';
export function fixTopSpacingOnMobile(sections) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var firstSection = sections[0];
    if (firstSection.type === SectionType.topSpacer) {
        return handleFirstSection([
            firstSection.height,
            ((_b = (_a = sections[1]) === null || _a === void 0 ? void 0 : _a.outerPadding) === null || _b === void 0 ? void 0 : _b.top) || 0,
            ((_d = (_c = sections[1]) === null || _c === void 0 ? void 0 : _c.innerPadding) === null || _d === void 0 ? void 0 : _d.top) || 0,
        ]);
    }
    else {
        return handleFirstSection([
            ((_f = (_e = sections[0]) === null || _e === void 0 ? void 0 : _e.outerPadding) === null || _f === void 0 ? void 0 : _f.top) || 0,
            ((_h = (_g = sections[0]) === null || _g === void 0 ? void 0 : _g.innerPadding) === null || _h === void 0 ? void 0 : _h.top) || 0,
        ]);
    }
}
function calculateMobileTopSpacingProportion(paddings) {
    var maxMobileTopSpace = 40;
    var desktopTopSpace = sum(paddings);
    if (desktopTopSpace <= maxMobileTopSpace) {
        return paddings;
    }
    var newPaddings = paddings.map(function (pad) {
        return Math.floor((maxMobileTopSpace * pad) / desktopTopSpace);
    });
    newPaddings[newPaddings.length - 1] =
        maxMobileTopSpace -
            (sum(newPaddings) - newPaddings[newPaddings.length - 1]);
    return newPaddings;
}
function handleFirstSection(spacings) {
    var smallerSpacings = calculateMobileTopSpacingProportion(spacings);
    var lastIndex = smallerSpacings.length - 1;
    return {
        margin: sum(smallerSpacings.slice(0, lastIndex)),
        padding: smallerSpacings[lastIndex],
    };
}
function sum(array) {
    return array.reduce(function (acc, x) { return acc + x; }, 0);
}
//# sourceMappingURL=css-utils-top-padding.js.map